module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch1",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "CT",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', {
    attrs: {
      "aria-label": "6",
      "id": "pg_6",
      "role": "doc-pagebreak"
    }
  }, [_c('samp', {
    staticClass: "SANS_Northwell_Clean_Regular_17"
  }, [_vm._v("Using this book")])])])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Over the following pages, after a brief overview of the materials I use daily, we’ll start to explore the basics of watercolor. I’ll share some essential information about lighting and shading, the first principles of color, and some further notions about fashion illustration. Following up, we’ll focus on the human figure, with specific information about the face, hair, and body, then later we’ll move on to how to render fabrics, textures, and prints with watercolor.")])]), _vm._v(" "), _c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img100",
    attrs: {
      "alt": "",
      "src": "images/pg6.jpg"
    }
  })]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Bold_B_17"
  }, [_vm._v("THE TUTORIALS")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("The core of the book is represented by a series of twenty tutorials. These projects have been conceived to take you gradually from the basics of watercolor fashion illustration to more articulated artwork. Completing these tutorials will allow you to build up a strong portfolio that investigates womenswear, menswear, accessories, beauty, and more.")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("This book is filled with all my love for watercolor and fashion illustration. It highlights my method and way of working. Page by page, I’ll give you meaningful insights and tips about my modus operandi, with the aim of supporting your vision in order to find your voice and explore your own universe.")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Bold_B_17"
  }, [_vm._v("YOUR FASHION ILLUSTRATION JOURNEY")])]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("I would love for you to see this book as the beginning of your explorations into watercolor fashion illustration. More than that, I wish for this journey to be packed with joy, curiosity, and excitement, which are to this day the foundations of my practice.")])]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": "7",
      "id": "pg_7",
      "role": "doc-pagebreak"
    }
  }, [_c('figure', {
    staticClass: "IMG"
  }, [_c('img', {
    staticClass: "img100",
    attrs: {
      "alt": "",
      "src": "images/pg7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Box-head"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Medium_B_17"
  }, [_vm._v("A BRIEF HISTORY OF FASHION ILLUSTRATION")])]), _vm._v(" "), _c('p', {
    staticClass: "Box-body"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("The blooming of modern fashion illustration in the early 20th century is inextricably linked to the historical, social, and economic background that led fashion to develop as a real and profitable business. Fashion magazines like Vogue and Harper’s Bazaar were beginning to flourish in the USA alongside the new fashion industry, and they needed to show their readers the key pieces and trends of each season. This offered a spotlight to fashion illustrators and their art. The covers and pages of these magazines presented faithful renditions of the garments and their textures, inspiring desire in consumers and contributing to the development of the fashion market.")])]), _vm._v(" "), _c('p', {
    staticClass: "Box-body"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("This period is often considered the “golden age” of fashion illustration, but it hit a setback when photography revolutionized the industry, giving a more accurate and true representation of the clothes. Although on the one hand this limited the role of fashion illustration for many years, it also allowed its transition to exciting new ways to explore fashion, trends, and style. It enabled illustrators to push the boundaries of creativity and eventually cemented fashion illustration’s position as an alternative to photography.")])]), _vm._v(" "), _c('p', {
    staticClass: "Box-body"
  }, [_c('samp', {
    staticClass: "SANS_Menco_Light_17"
  }, [_vm._v("Over the decades, pivotal figures like René Gruau, Antonio Lopez, and Jean-Philippe Delhomme, among many others, led the way for a new generation of illustrators that have given new worth to fashion illustration. Without the need to portrait and render fashion precisely, illustrators have had the chance to propel their artistry to new levels and in different directions, laying the foundations of contemporary fashion illustration. Now the accent is on expression, inspiration, interpretation, and much more.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5739cb62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1.vue
// module id = 69
// module chunks = 0